var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = /雨/.test(_vm.today.weather)
  var g1 = "少云,多云,阴,雾,霾".indexOf(_vm.today.weather)
  var g2 = /晴/.test(_vm.today.weather)

  var l0 = _vm.__map(_vm.weatherList, function(item, index) {
    var m0 = _vm.getWeatherImg(item.weather)
    return {
      $orig: _vm.__get_orig(item),
      m0: m0
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }